import { useEffect, useState } from "react";

export const useSearch = (search: string, delay = 500) => {
    const [value, setValue] = useState(search);

    useEffect(() => {
        const timer = setTimeout(() => setValue(search), delay);
        return () => clearTimeout(timer);
    }, [search, delay]);

    return value;
}